/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {autoCompleteAddress} from '../api'

export const useMutationAutoCompleteAddress = createReactQueryMutationHook('autoCompleteAddress', autoCompleteAddress)
